<template>
  <div class="TraceDetail">
    <el-dialog title="追溯详情" width="80%" :visible.sync="traceView" style="height: 1000px;" @close="cancelAddDialog">
      <div class="order-body">
        <div class="tree-left">
          <el-tree :data="nodeList" node-key="id" :default-expand-all="true" :props="defaultProps" :expand-on-click-node="false" @node-click="chonseMaterial"> </el-tree>
        </div>
        <div class="tree-right">
          <div class="topLine">
            <el-row>
              <el-col :span="8">批次号：{{ chonseOrderInfo.productionBatchCode }}</el-col>
              <el-col :span="8">源订单号：{{ chonseOrderInfo.orderCode }}</el-col>
              <el-col :span="8">工艺名：{{ traceDetail.technologyCode }} </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">物料编码：{{ chonseMaterialInfo.materialCode }}</el-col>
              <el-col :span="8">物料类型：{{ chonseMaterialInfo.itemType == 0 ? "产品" : "零件" }}</el-col>
              <el-col :span="8">数量：{{ traceDetail.splitCount == null ? "0" : traceDetail.splitCount }}{{ traceDetail.unitOfQuantity }}</el-col>
            </el-row>
          </div>
          <div class="dataDiv noData" v-if="!isData">
            暂无追溯数据
          </div>
          <div class="dataDiv" v-if="isData">
            <el-row v-if="isBatch">
              <el-col
                >物料批次号：
                <el-checkbox-group @change="checkedMaterialBatch" v-model="checkedMaterialBatchList">
                  <el-checkbox v-for="materialBatch in materialBatchList" :label="materialBatch.produceMaterialBatchCode" :key="materialBatch.produceMaterialBatchCode"></el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-row>
            <div v-for="oneBatchTraceInfo in traceDetail.listMap" :key="oneBatchTraceInfo.id" class="traceList">
              <div style="text-align: center; font-size: 22px;">{{ oneBatchTraceInfo.materialBatchCode }}</div>
              <el-table :data="oneBatchTraceInfo.list" style="width: 100%" height="500">
                <el-table-column fixed prop="deviceCode" label="设备编号" width="120"> </el-table-column>
                <el-table-column prop="factoryModelName" label="机组" width="120"> </el-table-column>
                <el-table-column prop="procedureName" label="工序名" width="120"> </el-table-column>
                <el-table-column prop="procedureCode" label="工序编号" width="140"> </el-table-column>
                <el-table-column prop="materialCode1" label="物料编码" width="120"> </el-table-column>
                <el-table-column prop="materialName1" label="物料名称" width="120"> </el-table-column>
                <el-table-column prop="operationType" label="操作类型" width="80"> </el-table-column>
                <el-table-column prop="operationNum" label="数量" width="80"> </el-table-column>
                <!-- <el-table-column prop="currentMaterialNum" label="当前物料数" width="80">
                                </el-table-column> -->
                <!-- <el-table-column prop="qualifiedProcessCount" label="完工数" width="80">
                                </el-table-column> -->
                <el-table-column prop="userName" label="操作人" width="80"> </el-table-column>
                <el-table-column prop="operationTime" label="操作时间" width="160" :formatter="$commonUtil.changeToDate"> </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TraceDetail",
  props: {
    isShow: Boolean,
    rowData: Object
  },
  watch: {
    isShow: function(newVal, oldVal) {
      this.traceView = this.isShow;
      if (this.isShow == true) {
        this.chonseOrderInfo = commonUtils.cloneObj(this.rowData); //父级传过来的参数
        this.chonseMaterialInfo = this.chonseOrderInfo;
        console.log("chonseMaterialInfo:" + JSON.stringify(this.chonseMaterialInfo));
        this.chonseOrderId = this.chonseOrderInfo.id; //当前订单中ID
        this.getBomIdByMaterialId(this.chonseMaterialInfo.materialId); //获取bom节点树
        this.getMaterialBacth(this.chonseOrderId, this.chonseMaterialInfo.materialId); //获取物料批次
      } else {
        this.chonseOrderInfo = {};
        this.chonseMaterialInfo = {};
      }
    }
  },
  data() {
    return {
      isData: false,
      isBatch: false,
      materialBatchList: [],
      chonseOrderInfo: {}, //列表选中的参数
      defaultProps: {
        children: "next",
        label: "materialCode"
      },
      checkedMaterialBatchList: [],
      traceView: false,
      chonseMaterialInfo: {}, //选中物料信息
      chonseOrderId: "", //选中订单ID
      nodeList: [],
      traceDetail: {}
    };
  },
  created() {},
  mounted: async function() {},
  methods: {
    dataInit() {
      this.traceDetail = {};
      this.checkedMaterialBatchList = [];
      this.isData = false;
      this.isBatch = false;
    },
    checkedMaterialBatch() {
      this.getTraceDetail(this.checkedMaterialBatchList);
    },
    async getMaterialBacth(orderId, materialId) {
      this.dataInit();
      //console.log(orderId, materialId);
      let { data } = await this.$RequestUtil.getAsync({
        url: "/api/productionPlan/getProduceMaterialBatchInfo",
        type: "sync",
        params: {
          orderId: orderId,
          materialId: materialId
        }
      });
      this.materialBatchList = data;
      if (this.materialBatchList.length > 0) {
        this.isBatch = true;
        this.checkedMaterialBatchList.push(this.materialBatchList[0].produceMaterialBatchCode);
      }
      this.getTraceDetail(this.checkedMaterialBatchList);
    },
    //获取追溯详情
    async getTraceDetail(checkedMaterialBatchList) {
      let { data } = await this.$RequestUtil.postAsync({
        url: "/api/order/getTraceBackDetail",
        type: "sync",
        params: {
          orderId: this.chonseOrderInfo.id,
          produceMaterialBatchCodes: checkedMaterialBatchList,
          materialId: this.chonseMaterialInfo.materialId
        }
      });
      if (data.listMap != null && data.listMap.length > 0) {
        this.isData = true;
        for (let i = 0; i < data.listMap.length; i++) {
          const oneBatch = data.listMap[i];
          let firstLength = oneBatch.list.length;
          for (let j = 0; j < oneBatch.list.length; j++) {
            const pplist = oneBatch.list[j];
            for (let z = 0; z < pplist.length; z++) {
              const oneTrace = pplist[z];
              oneBatch.list.push(oneTrace);
            }
          }
          for (let k = 0; k < firstLength; k++) {
            oneBatch.list.splice(0, 1);
            //oneBatch.list.splice(k, 1);
          }
        }
      }
      this.traceDetail = data;
      console.log("traceDetail:" + this.traceDetail);
    },
    //选中左侧物料
    chonseMaterial(data) {
      this.chonseMaterialInfo = data;
      this.getMaterialBacth(this.chonseOrderId, this.chonseMaterialInfo.materialId);
    },
    //关闭弹窗
    cancelAddDialog() {
      this.dataInit();
      this.nodeList = [];
      this.isShowDialog = false;
      this.$parent.showDetailView = false;
    },
    //根据物料ID获取物料在BOM树中的ID
    async getBomIdByMaterialId(materialId) {
      let { data } = await this.$RequestUtil.postAsync({
        url: "/api/bomStructure/getBomStructureByMaterialId",
        type: "sync",
        params: { materialId }
      });
      if (data > 0) {
        this.loadNodeList(data);
      } else {
        this.nodeList.push({
          materialId: this.chonseOrderInfo.materialId,
          materialName: this.chonseOrderInfo.materialName,
          materialCode: this.chonseOrderInfo.materialCode,
          next: []
        });
      }
    },
    //根据物料ID获取BOM树
    async loadNodeList(id) {
      let { data } = await this.$RequestUtil.getAsync({
        url: "/api/bomStructure/getBomStructure",
        type: "sync",
        params: { id }
      });
      this.nodeList = data;
    }
  }
};
</script>

<style scoped>
.order-body {
  overflow: hidden;
  margin-top: 20px;
}
.tree-left {
  float: left;
  width: 20%;
}
.tree-right {
  width: 72%;
  float: left;
  border-left: 1px solid;
  padding-left: 20px;
}
.traceList {
  margin: 10px;
}
.traceTitle {
  font-size: 18px;
  font-weight: bold;
  margin: 10px;
}
.el-checkbox-group {
  display: inline !important;
}
.topLine .el-row {
  margin-bottom: 26px;
}
.dataDiv {
  min-height: 400px;
  max-height: 700px;
}
.noData {
  text-align: center;
  line-height: 80px;
}
</style>

<style>
#TraceDetail .el-dialog__body {
  padding: 0 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/trace/TraceDetail.vue